export default __webpack_public_path__ + "static/media/gradient.44c3392f.svg";